import SurveyBaseController from './survey_base_controller';

// Public shareable Response page (card #3024). Renders the same real,
// read-only SurveyJS survey as the internal response_modal
// (surveys/result_controller.js -- survey.mode = 'display', the shared
// camera-upload-question/camera-mult-upload-question custom types), but
// reads survey_json/result_json embedded directly into the page instead of
// fetching them from /api/v1/surveys/results/results.json. That endpoint
// requires authenticate_user! -- this page has already authorised public
// access server-side via Response#shareable? before this controller's mount
// point ever renders, so no new public/unauthenticated JSON API is added.
//
// Camera/multi-camera question answers already carry
// {"name", "type", "content": image_url} (Response#build_result_json_entry)
// -- SurveyJS's native `file` question type (both custom camera types
// inherit from it) renders these as an inline image preview in display
// mode with no extra wiring needed.
export default class extends SurveyBaseController {
  static values = {
    survey: Object,
    result: Object
  }

  connect() {
    super.connect();
    const survey = this.initializeSurvey('display');
    survey.fromJSON(this.surveyValue);
    survey.data = this.resultValue;
    survey.render(this.element);
  }
}
